export default {
  messages: {
    content: {
      home: "Homes",
      product: "Products",
      confirm: "Are you sure to log out?",
      case: "Cases",
      conpany: "News",
      service_support: "Helper",
      helper: "Helper",
      about: "About",
      shiledApp: "Super Shields(APP Version)",
      defenceIp: "High-defense IP",
      shiledPc: "Super Shields(PC Version)",
      defenceServer: "High-defense Server",
      h5Shield: "Super Shields(H5 Version)",
      shiledWeb: "Super Shields(Web Version)",
      ec: "E-commerce Solutions",
      chess: "Chess Solutions",
      game: "Gaming Solutions",
      more: "More",
      detail: "Details",
      free: "Free Trial",
      buy: "Buy",
      function: "PRODUCT FEATURES",
      introduce:
        "Super Shield Web Edition (distributed Web application cloud firewall), a professional, cost-effective cloud security defense product for websites, Web games, H5 games and other fields. Web applications are mainly based on common protocols such as HTTP / HTTPS, which are very vulnerable to attacks. Super Shield (web version) fully defends against all types of DDoS / CC attacks, automatic triggering, real-time protection, load balancing, cluster protection, encrypted transmission, page performance optimization, Improve website access capabilities, hide source site IP, and ensure system security and availability.",
      necc:
        "The website must defend against DDoS / CC and other necessary products",
      pro: "Help tens of millions of customers solve website traffic attacks",
      ge: "Personalized customized packages",
      sati:
        "Meet different protection needs, customer satisfaction rate is as high as 100%",
      getit:
        "Super Shield (Web version) domestic basic protection package (customizable)",
      norm: "norm",
      parameter: "parameter",
      DDoSbase: "DDoS basic protection (BGP)",
      DDoSf: "DDoS traffic protection (peak)",
      exc500: "More than 500G can be customized",
      general: "General CC defense (IP per hour)",
      unlimited: "Unlimited",
      customizable: "Customizable",
      support: "Support",
      depth: "Depth",
      bandwidth: "Business bandwidth",
      qps: "QPS peak",
      supportnum1: "Support the number of first-level domain names",
      supportnum1: "Support the number of second-level domain names",
      normaltra: "Peak normal traffic (per hour)",
      attack: "Attack IP blocking time",
      limitspeed: "Intelligent speed limit",
      superpro: "Super protection",
      superprolimit: "Super range protection",
      bwlist: "Black and white list",
      cussupport: "Customer Support",
      consult: "Proprietary technology consultant",
      attack: "Attack protection strategy maintenance",
      attacklan: "Web attack interception",
      zeroday: "0Day Vulnerability Virtual Patch",
      iplist: "IP / UPL black and white list",
      single: "Exclusive IP protection",
      superserve: "Expert Service for Protection Strategy Optimization",
      addwaf: "Enhanced WAF",
      tamperproof: "Web page tamper-proof",
      consultpri: "Consultation package price",
      sensitivedata: "Sensitive data leakage prevention",
      allweb: "All industry websites can be accessed",
      cantkill:
        "Can not be killed, can be prevented, to ensure the stable operation of business",
      websiteweb: "Website Web Defense Access Process",
      threestep: "Three simple steps, no limit to defense",

      pro_ads: "PRODUCT ADVANTAGE",
      server: "SERVICE RECOMMENDATION",
      framework: "SCHEME FRAMEWORK",
      confirm: "Are you sure to log out?",
      onlineConsulting: "Online Consulting",
      freeTrial: "Free Trial",
      product_function: "Product Function",
      product_advs: "Product Advantages",
      product_config: "Product Config",
      compare_advs: "Comparative Aavantage ",
      customer_group: "Customer Group",
      customers_group: "CUSTOMER GROUP",
      customer_case: "Customer Case",
      node_distribution: "Node Distribution",
      other_recommendation: "Other Services",
      other_service: "Other Services",
      v_chess: "Chess ",
      v_game: "Game ",
      e_Commerce: "E-Commerce ",
      financial: "Financial ",
      Government_Enterprise: "Government and Enterprise ",
      tel: "400-108-9688",
      email: "chaojidun@chaojidun.com",
      hour: "(7*24h)",
      service_hotline: "The National Unified Service Hotline",
      exclusive_answerer: "Online Q & A",
      scan_QR_code: "Scan QR Code",
      attention: "Follow the public account",
      solution_one: "Professional customized solutions",
      solution_two:
        "For each industry business characteristics, to provide you with a one-stop security solutions",
      correlation: "Related products",
      consult: "Online Consulting",
      advantage: "Advantages and characteristics",
      EC: "E-Commerce",
      EC_solution: "E-commerce Solutions",
      EC_text:
        "Aiming at the high concurrency, garbage flow, malicious brushing, sudden large-scale malicious attacks and vulnerability attacks in the e-commerce industry, we develop exclusive solutions to help e-commerce customers deal with various business problems, ensure the security of e-commerce transactions and smooth completion of e-commerce activities!",
      EC_advantage_text:
        "Efficient defense against DDoS attack, CC attack, vulnerability prevention, tamper-proof, ANTI-SQL injection, data fingerprint verification, intelligent DNS, intelligent cache, providing 7*24 hours security operation and maintenance guarantee services.",
      Game: "Game",
      game_solution: "Gaming Solutions",
      game_text:
        "Meet the security requirements of mobile APP, PC and other scenarios.Defend against heavy traffic attack and CC attack;Intelligent acceleration, the game card does not drop the line.The APP is reinforced to prevent reselling game coins, cheating and wool pulling.Massive accumulation of attack and defense combat, creating reliable security solutions for game operation.",
      game_advantage_text:
        "Distributed architecture, intelligent routing, weak network acceleration, game card no drop;No upper limit defense DDoS, 100% anti-CC, completely no sense when attacked, support mobile APP, PC side game scene, effectively prevent reselling game coins, prevent cheating, prevent wool pulling and other behaviors.",
      Financial: "financial",
      financial_solution: "Financial Solutions",
      financial_text:
        "Through multiple dimensions, business, data from the network in the application for financial customers, business, and the available security areas to provide tailored personalized security solutions, through the three-dimensional protective mechanism against a variety of malicious attacks, huge amounts of calculation, flexible deployment solution to the business a huge number of concurrent with senior security expert service, help the financial industry achieve full compliance, sustainable development, business and data security.",
      financial_advantage_text:
        "为HTTP/It provides SQL injection, XSS cross-site, Webshell upload, unauthorized access and other Web service attack protection functions for HTTP/HTTPS service, and provides T-level DDoS traffic cleaning protection and TEN-million-level CC protection for abnormal request filtering.",
      education: "Education Industry",
      education_solution: "Education Industry Solutions",
      education_text:
        "In view of the education informatization development facing the network vulnerability and risk of data leakage, for mobile APP strengthening, Web education sector firewall, prevent hackers malicious tampering, code insertion, against big flow attack and attack CC, provide education class APP, website compliance, security solutions, assist the safety of the education informationization development.",
      education_advantage_text:
        "Comprehensively strengthen the mobile APP to prevent hijacking, Trojan, invasion and tampering, and provide SQL injection, XSS cross-site, Webshell upload, unauthorized access and other Web service attack protection functions.",
      customized: "Custom",
      customized_solution: "Custom Solutions",
      customized_text:
        "Provide 1V1 exclusive security expert services, quickly respond to customer needs, and develop proprietary security solutions.",
      customized_advantage_title_one: "Ex ante - risk assessment",
      customized_advantage_title_two: "In the middle - regular inspection",
      customized_advantage_title_three: "After-the-fact - Emergency response",
      customized_advantage_text_one:
        "The safety technical team provides comprehensive safety monitoring and reinforcement services.",
      customized_advantage_text_two:
        "The safety technical team regularly assists users in daily monitoring and inspection.",
      customized_advantage_text_three:
        "The safety technical team will assist users in emergency response within one hour.",
      product_superiority: "Product advantages and strength",
      product_superiority_text:
        "A must-have for website defense against CC/DDoS traffic attacks",
      prevent: "Defensible",
      prevent_text: "CC attack defenses have no upper limit regardless of DDoS",
      use: "用得起",
      use_text: "收费标准统一透明，高性价比受信赖",
      play: "玩得好",
      play_text: "SDN实现智能动态加速保障最佳用户体验",
      look: "看得见",
      look_text: "自主可视化后台管理网络状态一目了然",
      quick: "上得快",
      quick_text: "只需一句话嵌入SDK即可实现完美对接",
      defense_capability: "全网防御能力",
      hard_defense_capability: "硬防能力",
      cleanout_center: "东南亚清洗中心",
      CC_defense: "CC防御",
      defense_node: "防御节点",
      use_client: "应用客户",
      node_distribution: "节点分布",
      node_distribution_text: "全球无缝对接，BGP线路，自选节点数",
      partner: "合作伙伴"
    },
    help: {
      service_support: "服务支持",
      service_support_text:
        "超级科技为您提供7×24小时的专业服务，以及多样化的支持服务，满足您从上云部署、日常运维到优化升级等的全周期需求。",
      safeguard_title: "7*24小时保障",
      safeguard_text: "全天候管家式服务",
      major_title: "专业技术服务",
      major_text: "在线防御专家指导",
      cost_performance_title: "极高性价比",
      cost_performance_text: "成本低、收费透明",
      client_service: "客户服务",
      consultation_service_title: "专业的咨询规划服务",
      consultation_service_text:
        "为客户提供专业的产品和服务介绍，针对客户的实际应用和需求，量身定制整体解决方案，全程跟踪项目，为项目的实施提供技术支持。",
      technical_support_title: "1V1技术支持",
      technical_support_text:
        "提供一对一的技术服务。专属技术经理会在服务期内提供专业的技术支持。更快定位并解决问题，为您提供有针对性技术支持和服务。",
      service_hotline_title: "客户服务热线",
      service_hotline_text:
        "提供在线客服服务，包括400电话、在线客服以及邮件等方式，全面保障您的业务正常运转。",
      help_document: "帮助文档",
      join_up_title: "接入流程",
      join_up_text: "新用户使用流程指导",
      shiled_app_title: "超级盾SDK",
      shiled_app_text: "超级盾添加源机指南",
      web_firewall_title: "Web防火墙",
      web_firewall_text: "Web防火墙添加源机指南",
      defence_ip_title: "高防服务器IP",
      defence_ip_text: "高防服务器购买指南",
      view_details: "查看详情",
      FAQ: "常见问题",
      question_one: "注册超级盾账户时收不到验证码怎么办？",
      answer_one:
        "由于欠费停机、存储信息已满、信号网络延迟等原因没有及时收到验证码，这时请检查您的手机及话费余额，保证手机可正常接收短信后，请尝试重新获取验证码。",
      question_two: "支持哪些语言的服务端SDK？",
      answer_two:
        "目前支持各项服务的Java、PHP、Python、C#、Node.js版本服务端SDK，我们会尽快陆续推出更多语言支持，请您持续关注。",
      question_three: "新账号进入时没有选择专属客服？",
      answer_three:
        "系统后台会自动分配专属客服，如果您之前有专门对接经理，直接联系对接经理添加即可。",
      question_four: "我可以创建多少个应用？",
      answer_four: "每项服务创建应用没有上限。",
      question_five: "目前都开放了哪些服务？",
      answer_five:
        "目前APP 盾，Web 盾，高防服务器 这三项技术您可以直接在控制台中使用。",
      question_six: "流量数据显示不准确？",
      answer_six:
        "相关数据是根据客户绑定软件实时反应，如觉得数据有差异可直接联系客服!",
      question_seven: "日活等数据能不能在手机浏览？",
      answer_seven:
        "超级盾有专门的APP系统供客户使用，直接联系专属客服下载即可。",
      question_eight: "添加源机有没有上限？",
      answer_eight: "当前应用下，服务器最多255台。",
      more: "更多"
    },
    information: {
      company_dynamic: "公司动态资讯",
      company_news: "公司动态",
      trade_news: "行业新闻"
    },
    about: {
      title: "安全首位梦想",
      company_name: "杭州超级科技有限公司",
      value_title_one: "重视我们的价值",
      value_title_two: "创造价值和成就价值",
      value_text_one: "以客户为中心",
      value_text_two: "为客户提供防得好、体验佳、成本低的产品和服务",
      value_text_three: "持续追求高效运作、技术领先，不断提升公司核心竞争力",
      mission: "使命",
      mission_text: "安全守卫梦想",
      vision: "愿景",
      vision_text: "成为云计算安全领域的领军企业",
      value: "价值观",
      value_text: "诚信、责任、梦想",
      contact_phone: "联系电话",
      url: "网址:",
      email: "邮箱:",
      address: "地址:",
      address_text:
        "B1102,11th Floor, 3rd Blocking, Chuangxin Times Plaza, Yuhang District, Hangzhou City, Zhejiang Province, PRC."
    },
    footer: {
      service_support: "服务支持",
      hot_product: "热门产品",
      successful_case: "成功案例",
      shiled_sdk_App: "超级盾SDK（APP）",
      shiled_pc_App: "超级盾SDK（PC）",
      web_firewall: "Web防火墙（网站）",
      higher_defense_ip: "高防服务器（IP）",
      hot_platform: "热门平台案例",
      live_broadcasting_platform: "直播平台案例",
      financial_company: "金融公司案例",
      help_document: "帮助文档",
      service_agreement: "服务协议",
      privacy_policy: "隐私政策",
      telephone_hotline: "7×24小时热线电话",
      email: "电子邮箱",
      download: "Android版下载"
    },
    product: {
      consult: "在线咨询",
      try_out: "免费试用",
      advantage: "产品优势",
      function: "产品功能",
      solution: "解决方案",
      case: "客户案例",
      architecture: "部署架构",
      join_up: "接入流程",
      shiledApp: {
        banner_title: "超级盾SDK（APP）",
        banner_text:
          "专门服务于手机APP的DDoS分布式云防御(无限防)，同时可以100%过滤CC攻击以及完全无视DNS攻击。",
        advantage_one_title: "防御效果好",
        advantage_one_text: "无限防御DDoS、100%防CC；受攻击时业务完全无感。",
        advantage_two_title: "防薅羊毛",
        advantage_two_text:
          "通过大数据分析，智能识别非法用户的行为，防薅羊毛。",
        advantage_three_title: "性价比极高",
        advantage_three_text:
          "防御成本低于传统高防1/2；收费透明，按日活跃用户(DAU)收费，享受无上限的防御能力。",
        advantage_four_title: "数据更安全",
        advantage_four_text:
          "不解析用户任何协议，不干涉用户数据内容，盾机双向采用AES256对业务数据进行加密。",
        function_one_title: "无视DDoS",
        function_one_text_one: "隐藏源机IP",
        function_one_text_two: "无限防御DDoS",
        function_one_text_three: "盾机受攻击，业务无感。",
        function_two_title: "100%防御CC攻击",
        function_two_text_one: "指纹验证合法用户",
        function_two_text_two: "100%拦截CC。",
        function_three_title: "双盾合一组网",
        function_three_text_one: "主链路采用超级盾(APP版)",
        function_three_text_two: "采用800G高防IP作为备选链路",
        function_three_text_three: "业务动态感知,无需手动切换。",
        function_four_title: "保障用户数据安全",
        function_four_text_one: "防劫持、木马、入侵；",
        function_four_text_two: "采用AES256数据双向加密",
        function_four_text_three: "防APP篡改。",
        function_five_title: "智能路由",
        function_five_text_one: "基于AI智能算法",
        function_five_text_two: "动态适配最佳路由",
        function_five_text_three: "弱网加速。",
        function_six_title: "管理可视化",
        function_six_text_one: "图形化自定义网络架构",
        function_six_text_two: "攻击图形化监控,攻击源轻松追",
        function_six_text_three: "溯,消费账单一目了然。",
        function_seven_title: "用户级动态调速",
        function_seven_text_one: "管理颗粒度小",
        function_seven_text_two: "针对单独用户",
        function_seven_text_three: "TCP通讯加速/限速管理。",
        function_eight_title: "全天候防御",
        function_eight_text_one: "流量实时经过盾机",
        function_eight_text_two: " 盾机7*24小时全天候防御。",
        double_shield: "双盾组网",
        distributed: "分布式盾池",
        synopsis:
          "主链路采用超级盾(APP版)，采用800G高防IP作为备选   链路，业务动态感知，无需手动切换",
        solution_advantage_title: "优势",
        solution_advantage_text_one: "性价比极高，攻击规模越大优势越明显",
        solution_advantage_text_two: "7*24小时全天候防御",
        solution_advantage_text_three: "防御性能好，不中断业务，不误封IP",
        solution_advantage_text_four:
          "优化网络资源分配，向用户提供最优的网络资源。对客户应用有加速能力，用户越多，网络越安全",
        solution_advantage_text_five:
          "不用解析任何协议，采用报文基因技术，可100%确 保只有合法报文流入受保护的服务器",
        solution_advantage_text_six: "无视DDoS、CC攻击，防御无上限",
        solution_advantage_text_seven:
          "客户级别无差异，无论大小客户，享受同等级别的安全保障",
        case_one_title: "广州某直播客户",
        case_one_text: "2019年5月28号600GCC攻击从16.39到17.27",
        case_two_title: "深圳某游戏公司",
        case_two_text: "2019年2月15日900GDDoS攻击从17.05到20.48"
      },
      shiledPc: {
        banner_title: "超级盾SDK（PC）",
        banner_text:
          "针对PC应用程序的防御系统，有无源代码均可接入，能够抵御一切DDoS攻击、CC攻击、TCP攻击等常见攻击手段。",
        download: "免费接入套件下载",
        advantage_one_title: "防御效果好",
        advantage_one_text: "无限防御DDoS、100%防CC；受攻击时业务完全无感。",
        advantage_two_title: "接入速度快",
        advantage_two_text: "接入简单，可接入SDK源码，也可直接封装登录工具。",
        advantage_three_title: "性价比极高",
        advantage_three_text:
          "防御成本低于传统高防1/2；收费透明，按日活跃用户(DAU)收费，享受无上限的防御能力。",
        advantage_four_title: "用户体验佳",
        advantage_four_text:
          "直接对接数据库中精准用户，允许针对单独用户TCP/UDP通讯加速。",
        function_one_title: "分布式架构、无视DDoS",
        function_one_text_one: "隐藏源机IP",
        function_one_text_two: "无限防御DDoS",
        function_one_text_three: "盾机受攻击，业务无感。",
        function_two_title: "100%防御CC攻击",
        function_two_text_one: "指纹验证合法用户",
        function_two_text_two: "100%拦截CC。",
        function_three_title: "双盾合一组网、主备两条链路",
        function_three_text_one: "主链路采用超级盾(APP版)",
        function_three_text_two: "采用800G高防IP作为备选链路",
        function_three_text_three: "业务动态感知,无需手动切换。",
        function_four_title: "保障用户数据安全",
        function_four_text_one: "防劫持、木马、入侵；",
        function_four_text_two: "采用AES256数据双向加密",
        function_four_text_three: "防APP篡改。",
        solution_one_title: "PC端游",
        solution_one_text:
          "PC端游很容易在开服或营销推广期间受到DDoS攻击、CC攻击，导致游戏客户端访问速度缓慢，掉线率升高，甚至导致用户流失，给PC游戏开发商带来不小的损失。",
        solution_two_title: "金融网站",
        solution_two_text:
          "互联网金融行业间的竞争比较激烈，金融类客户端也成为了DDoS、CC攻击的主要对象，这些攻击会导致金融客户端无法访问，提供正常的金融服务。",
        solution_three_title: "视频客户端",
        solution_three_text:
          "视频服务为了能提供给用户更好的使用体验，对服务器性能及网络质量的要求较高，当遭受DDoS攻击时对服务器集群的压力激增，严重影响用户使用感受导致客户流失。",
        solution_four_title: "互联网+业务",
        solution_four_text:
          "随着互联网的普及，越来越多的企业搭建企业门户客户端，使用各种企业管理系统，经常会遭到来自竞争组织的DDoS攻击、CC攻击，导致客户端无法提供企业服务，影响企业形象。"
      },
      webFirewall: {
        banner_title: "Web防火墙",
        banner_text:
          "Web防火墙对网站业务流量进行检测，识别恶意流量请求和防御未知威胁,确保客户的网络数据中心稳定运行，解决流量攻击带来的网站/服务器无法运行问题，DDoS防护无上限，100%防CC。",
        advantage_one_title: "无端易部署",
        advantage_one_text:
          "无需安装下载，不改源站程序，控制台自助服务，防御调整实时生效。",
        advantage_two_title: "多线路支持",
        advantage_two_text:
          "分布式部署多个BGP节点，覆盖多运营商骨干线路，网络时延小、访问速度快，保障稳定流畅的用户体验。",
        advantage_three_title: "动态防护",
        advantage_three_text:
          "根据攻击变化，系统就近分发，智能切换防护节点，实时下发防御规则，全网秒级生效。",
        advantage_four_title: "多协议支持",
        advantage_four_text:
          "HTTP/HTTPS/TCP/WebSocket协议，满足网页游戏、网站、即时通软件等类型的业务需求。",
        advantage_five_title: "极速部署",
        advantage_five_text:
          " 5分钟即可完成部署，实现应急防护，最大限度减少损失。",
        advantage_six_title: "灵活计费",
        advantage_six_text:
          "个性化定制各项防护策略，按需购买产品服务，弹性动态调整，节省防护成本。",
        why: "为什么选择Web防火墙",
        why_one_title: "分布式Web应用云防火墙",
        why_one_text:
          "WEb防火墙是针对网站、Web游戏、H5游戏等领域推出的专业、高性价比的云安全防御产品。",
        why_two_title: "自动触发，实时防护",
        why_two_text:
          "Web防火墙全面防御所有类型DDoS/CC攻击，自动触发，实时防护，负载均衡，集群防护，加密传输，页面性能优化，提升网站访问能力，隐藏源站IP，保证系统安全和可用性。"
      },
      higherDefenseIp: {
        banner_title: "高防IP",
        banner_text:
          "高防IP是为服务器大流量DDoS攻击的防御产品，可通过配置高防IP，将攻击引流到高防IP，确保源站的服务稳定。",
        advantage_one_title: "大流量清洗",
        advantage_one_text:
          "无限防御DDoS、100%1T以上DDoS清洗能力、独创CC防御算法。",
        advantage_two_title: "全业务支持",
        advantage_two_text:
          "无限防御DDoS、100%1T以上DDoS清洗能力、独创CC防御算法。",
        advantage_three_title: "性价比极高",
        advantage_three_text:
          "防御成本低于传统高防1/2；收费透明，按日活跃用户(DAU)收费，享受无上限的防御能力。",
        advantage_four_title: "接入速度快",
        advantage_four_text: "CNAME方式或将源站A记录解析到高防IP，秒级接入。",
        function_one_title: "大流量DDoS清洗",
        function_one_text_one: "清洗中心位于运营商骨干网核",
        function_one_text_two: "心节点机房出口1.4T；",
        function_one_text_three: "1T以上DDoS清洗能力。",
        function_two_title: "100%先进的CC防御算法",
        function_two_text_one: "独创CC防御技术，防御策略有 ",
        function_two_text_two: "100%302重定向、HTTPS证书、令",
        function_two_text_three: "牌桶算法、大数据过滤等。",
        function_three_title: "云WAF",
        function_three_text_one: "防SQL注入，防篡改，防漏",
        function_three_text_two: "洞，防数据泄露；大数据分析",
        function_three_text_three: "技术。",
        function_four_title: "全业务支持",
        function_four_text_one: "支持TCP/UDP/HTTP/HTTPS",
        function_four_text_two: "适合游戏、金融、电商、门",
        function_four_text_three: "户、媒体等行业。",
        function_five_title: "源站隐藏",
        function_five_text_one: "访问流量经由高防IP转发到源",
        function_five_text_two: "站，不暴露源站IP，隐藏源站",
        function_five_text_three: "踪迹。",
        function_six_title: "弹性防护",
        function_six_text_one: "支持随时升级到更高级别的防",
        function_six_text_two: "护，升级过程服务无中断。",
        function_seven_title: "精准攻击流量图",
        function_seven_text_one: "提供实时精准的流量图，",
        function_seven_text_two: "您可及时、准确地获得",
        function_seven_text_three: "攻击状态与详情。",
        function_eight_title: "全业务支持",
        function_eight_text_one: "流量实时经过盾机",
        function_eight_text_two: "盾机7*24小时全天候防御。",
        why: "为什么选择高防IP",
        why_one_title: "确保源站的服务稳定",
        why_one_text:
          "高防IP是为服务器大流量DDoS攻击的防御产品，用户可通过配置高防IP，将攻击引流到高防IP，确保源站的服务稳定。您购买高防IP服务后，Web业务把域名解析指向高防IP；非Web业务，把业务IP替换成高防IP，并配置源站IP。",
        why_two_title: "无需额外做流量牵引和回注",
        why_two_text:
          "所有公网流量都经过高防IP，高防IP将攻击流量清洗后的正常流量回注到源站IP。配置高防IP服务后，当您遭受DDoS攻击时，无需额外做流量牵引和回注。"
      },
      leakproof: {
        banner_title: "数据防泄漏系统",
        banner_text:
          "数据防泄漏系统对企业敏感数据泄密渠道进行严密的检查和控制，加强敏感数据在创建、存储、使用、传输和销毁全生命周期的安全管理，防止泄漏行为发生、对疑似泄漏行为进行审计，为企业整体数据安全防护，提供态势分析和智能管控支撑。",
        advantage_one_title: "全协议兼容",
        advantage_one_text:
          "系统支持对http、https、FTP、smtp、smtps、常用即时通讯软件的网络协议进行识别匹配并管控处理。全面杜绝敏感数据从网络外泄。",
        advantage_two_title: "多模式快速匹配和正则后处理",
        advantage_two_text:
          "多模式匹配方法能将多个关键字特征构建成状态机，实现对文档进行一次遍历就能得到所有关键字的匹配结果。除关键字外，诸如身份证、银行卡等数字特征，也是敏感数据的主要表征方法。",
        advantage_three_title: "数据内容智能识别引擎",
        advantage_three_text:
          "系统集成基于深度内容识别技术的数据分析引擎，可精准快速分析文档语义，快速发现敏感信息。智能指纹不受文件格式和文档类型的影响，只要文档内容一致，即使文档类型变化，文件指纹也能够保持不变。",
        advantage_four_title: "集成自研OCR引擎",
        advantage_four_text: "集成图像处理引擎，可兼容jpg、png等图片数据分析。",
        advantage_five_title: "数据智能分类分级引擎",
        advantage_five_text:
          "系统具备集成自动分类及分级技术，实现数据的智能分类、分级，提高数据防泄漏的防护精度、降低误报。"
      },
      emailLeakproof: {
        banner_title: "邮件数据防泄漏系统",
        banner_text:
          "通过对互联网邮件协议的解析，按业务进行还原，根据制定的策略进行敏感数据匹配，一旦触发策略，根据策略的规则处理并上报策略服务器供后续的事件分类查询与统计，及时发现违规邮件及时处理，从而实现对所保护范围内的邮件数据进行防护。",
        advantage_one_title: "全场景邮件监控",
        advantage_one_text:
          " 邮件客户端、Web页面、邮件APP客户端等方式外发邮件，均可无缝控制，以确敏感数据邮件外发的安全。",
        advantage_two_title: "全协议监控及邮件审批",
        advantage_two_text:
          "兼容smtp/PoP3、smtps、ICMP等邮件协议。系统支持邮件审批功能，给客户提供全程数据溯源及跟踪机制。",
        advantage_three_title: "具备智能提速及高可用功能",
        advantage_three_text:
          "系统集成智能加速、高可用处理技术，保证邮件转发的高效、稳定，支持负载均衡、web双活、数据库双活、双网线绑定等技术。",
        advantage_four_title: "部署方式零感知",
        advantage_four_text:
          "系统旁路部署在交换机上即可，不影响客户单位的现网络拓扑正常运行。",
        architecture_title: "邮件数据防泄漏系统解决方案",
        architecture_text:
          "MDLP部署在邮件系统和邮件网关之间，扫描和管控内部员工外发的电子邮件，包括标题、内容和附件，对发现含有敏感信息的邮件进行隔离，交由相关人员审批，并根据审批结果对邮件进行放行或者阻止，最终实现对通过企业邮箱泄露敏感信息的精确管控。"
      },
      defenceServer: {
        banner_title: "高防服务器",
        banner_text:
          "全BGP线路接入，带宽、防御能力自由选择无防御上线可集成智能分布式集群防御功能。",
        advantage_one_title: "访问速度快",
        advantage_one_text:
          " 双节点和BGP，骨干网络带宽，有效保障访问速度体验。",
        advantage_two_title: "高稳定性",
        advantage_two_text:
          "采用三大运营商骨干网络标准化IDC，网络采用双链路和双交换机冗余，有效避免单点故障。",
        advantage_three_title: "高性价比",
        advantage_three_text:
          "基于集群防御和空闲带宽资源，能够为用户提供极具性价比的高防服务器，适用于中小型网站等场景。",
        advantage_four_title: "弹性扩展能力",
        advantage_four_text:
          "采用基础预付费+弹性后付费，既可以在避免带宽浪费的前提下进行有效防护，又可以节约成本。",
        function_one_title: "稳定",
        function_one_text_one: "运营商核心机房",
        function_one_text_two: "高性能服务器。",
        function_two_title: "安全",
        function_two_text_one: "50G-2.5Tbps真实",
        function_two_text_two: "1DDoS防御能力。",
        function_three_title: "快速",
        function_three_text_one: "直连运营商骨干网络",
        function_three_text_two: "保证网络通畅、高速。",
        function_four_title: "专业",
        function_four_text_one: "支持各类系统",
        function_four_text_two: "满足多种场景使用。",
        function_five_title: "省心",
        function_five_text_one: "7*24小时服务。",
        function_six_title: "省钱",
        function_six_text_one: "超高性价比。",
        function_seven_title: "透明",
        function_seven_text_one: "提供详细的使用报表。",
        function_eight_title: "保障",
        function_eight_text_one: "负载均衡，容灾部署。",
        config_one: "配置案例一",
        config_two: "配置案例二",
        config_three: "配置案例三",
        config_title: "高防服务器配置",
        line: "线路",
        line_type: "单电信",
        physical_config: "物理配置",
        bandwidth: "带宽",
        base_defense_capacity: "DDoS基础防御容量",
        cover_one: "覆盖电信线路",
        guaranteed_one: "保底带宽100G",
        cover_two: "覆盖电信、联通、移动和教育网等线路",
        guaranteed_two: "保底带宽300G，支持弹性扩容",
        computer_room: "五星机房"
      }
    },
    solution: {
      business_challenges: "业务挑战",
      product_advantage: "产品优势",
      security_architecture: "安全方案架构",
      shiledApp: "超级盾SDK（APP）",
      shiledApp_text:
        "分布式云防火墙，无限防DDoS，100%防CC攻击，不卡不掉线，智能加速，适合各类有端的应用系统的防御。",
      web_firewall: "Web防火墙（网站）",
      web_firewall_text:
        "分布式Web云安全防御产品，接入简单、急速部署、多线路支持、动态防护。",
      more: "了解更多",
      chess: {
        banner_title: "棋牌解决方案",
        banner_text:
          "针对棋牌游戏行业如倒卖游戏币，流量勒索攻击、游戏作弊等问题制定专属解决方案，抵御大流量攻击和CC攻击，进行APP加固等。结合多年的攻防实战经验，为游戏运营打造最全面、可信赖的安全解决方案。",
        challenges_one_title: "行业竞争激烈",
        challenges_one_text:
          "对于棋牌行业来说，地域属性极强，竞争对手较为明确，容易产生不当竞争行为，网络攻击成了业内绝杀武器。",
        challenges_two_title: "攻击方式复杂多变",
        challenges_two_text:
          "通过刷注册用户、破解签名算法、热更服务器、DDoS、CC等方面的攻击一直处于高频状态，攻击常达百G以上，攻击方式复杂多变，对于服务器端的攻击，应用层的攻击以及DNS攻击是防护难题。",
        challenges_three_title: "欺诈作弊",
        challenges_three_text:
          "攻击者利用自动化工具，通过扫库撞库等方式进行盗号，破解游戏客户端程序，改变游戏数据，外挂程序，破坏游戏生态平衡。",
        challenges_four_title: "卡顿和掉线",
        challenges_four_text:
          "很多棋牌游戏平台面临网络危机，经常出现卡顿、掉线，甚至打不开网站等情况，严重影响玩家体验度，导致平台运营艰难和玩家流失等后果。",
        advantage_one_title: "抗DDoS攻击",
        advantage_one_text:
          "防护海量DDoS攻击，有效抵御所有各类基于网络层、传输层及应用层的DDoS攻击，如syn flood、UDP flood、ICMP flood等攻击。",
        advantage_two_title: "精准防护零误封",
        advantage_two_text:
          "全自动检测和策略匹配，实现精准防护零误封，使业务更安全可靠。",
        advantage_three_title: "隐藏源站IP",
        advantage_three_text:
          "隐藏服务器真实IP地址，使攻击者无法找到受害者网络资源，增加源站安全性。",
        advantage_four_title: "超高性价比",
        advantage_four_text:
          "高度可定制的解决方案，满足不同阶段的业务成长需求，成本比大平台更实惠。",
        architecture_chess_title: "棋牌游戏解决方案",
        architecture_chess_text:
          "满足移动端APP、PC端和H5棋牌等各种场景安全需求，为游戏运营打造可信赖的安全解决方案。",
        architecture_target_title: "目标",
        architecture_target_text_one: "抵御大流量攻击和CC攻击",
        architecture_target_text_two: "智能加速，游戏不卡不掉线",
        architecture_target_text_three: "防作弊、防止薅羊毛",
        architecture_advantage_title: "优势",
        architecture_advantage_text_one: "全业务支持",
        architecture_advantage_text_two: "无上限防御",
        architecture_advantage_text_three: "不卡不掉线",
        architecture_advantage_text_four: "APP加固"
      },
      competitiveGame: {
        banner_title: "竞技游戏解决方案",
        banner_text:
          "针对竞技游戏行业的外挂，薅羊毛、恶意广告、恶意拉人、色情诈骗、DDoS攻击等黑产行为制定专属安全解决方案，抵御DDoS和CC攻击，多线路近源通信，智能调配，提高网络稳定性，游戏不卡不掉线，提供稳定、安全的游戏环境。",
        challenges_one_title: "高性能主机",
        challenges_one_text:
          "由于竞技游戏的实时竞技属性的特点，地图走位，技能、装备、人物属性频繁发生变化，需高性能服务器端进行大量运算，因此游戏运行主机性能和稳定性极为重要。",
        challenges_two_title: "高质量网络",
        challenges_two_text:
          "由于竞技游戏的玩法为即时战斗，客户端与服务器端频繁产生交互，对网络延时和稳定性要求非常高。",
        challenges_three_title: "安全问题复杂多变",
        challenges_three_text:
          "游戏在上线后，网络攻击层出不穷，包括Ddos、cc和应用层等方面的攻击等一直处于高频状态。游戏厂商往往缺乏应对手段，影响游戏正常运行，严重者将会造成游戏中断和玩家流失。",
        challenges_four_title: "故障快速迁移能力",
        challenges_four_text:
          "竞技类游戏通常单点服务，单机可靠性以及在单机故障后快速恢复的能力至关重要。",
        advantage_one_title: "高性能云服务器",
        advantage_one_text_one: "提供高性能云服务器ECS，云服务器",
        advantage_one_text_two: "计算资源独享，确保游戏服务",
        advantage_one_text_three: "稳定地运营。",
        advantage_two_title: "无上限防御",
        advantage_two_text_one: "无上限防御DDoS，超级盾(APP版)100%",
        advantage_two_text_two: "防CC，一站式解决游戏业主频繁被",
        advantage_two_text_three: "DDoS/CC攻击的烦恼。",
        advantage_three_title: "不卡不掉线",
        advantage_three_text_one: "被攻击时完全无感，游戏不卡不掉线",
        advantage_three_text_two: "分布式架构，智能路由、弱网加速，充",
        advantage_three_text_three: "分保障用户游戏体验。",
        advantage_four_title: "超高性价比",
        advantage_four_text_one: "高度可定制的解决方案，满足不同",
        advantage_four_text_two: "阶段的业务成长需求，成本比大平台",
        advantage_four_text_three: "更实惠。",
        architecture_competitive_title: "竞技游戏解决方案",
        architecture_competitive_text:
          "抵御DDoS和CC攻击，多线路近源通信，智能调配，提高网络稳定性，不卡不掉线，提供稳定、安全的游戏环境。",
        architecture_target_title: "目标",
        architecture_target_text_one: "抵御DDoS和CC攻击",
        architecture_target_text_two: "智能加速，游戏不卡不掉线",
        architecture_target_text_three: "防作弊、防止薅羊毛",
        architecture_advantage_title: "优势",
        architecture_advantage_text_one: "无上限防御",
        architecture_advantage_text_two: "高性能云服务器/CC攻击",
        architecture_advantage_text_three: "不卡不掉线",
        architecture_advantage_text_four: "超高性价比"
      },
      web_service: {
        banner_title: "web服务安全解决方案",
        banner_text:
          "无视一切DDoS/CC攻击，网站恶意流量清洗识别，将正常、安全的流量回源到服务器。避免网站服务器被恶意入侵，确保您的网络数据中心稳定运行，解决因流量攻击导致的服务器性能异常问题。",
        web_security_challenges: "web安全挑战",
        challenges_one_title: "黑客入侵",
        challenges_one_text:
          "撞库拖库进行信息盗取，篡改网页内容，通过后门木马将主机变成肉鸡实施攻击，加密数据库进行勒索等。",
        challenges_two_title: "业务欺诈",
        challenges_two_text:
          "羊毛党的垃圾注册，刷粉、刷票、刷积分等欺诈行为造成的业务损失。",
        challenges_three_title: "恶意内容",
        challenges_three_text:
          "涉黄、涉政、涉恐文字、图片或音视频导致的监管风险，影响品牌形象及业务运转。",
        advantage_one_title: "全面防护常见Web攻击威胁",
        advantage_one_text:
          "为HTTP／HTTPS业务提供SQL注入、XSS跨站、Webshell上传、非授权访问等多种Web服务攻击防护功能，保障网站的安全与可用性。",
        advantage_two_title: "无上限DDoS/CC攻击防护",
        advantage_two_text:
          "智能识别CC攻击，迅速识别CC攻击并进行拦截，在大规模CC攻击时可以避免源站资源耗尽，保证用户网站的正常访问。",
        advantage_three_title: "低误杀秒解封",
        advantage_three_text:
          "对访问频率过快的IP不再直接粗暴的封禁，而是综合URL请求、响应码等分布特征判断异常行为，全自动检测和策略匹配，实现精准防护，低误杀秒解封，使业务更安全可靠。",
        advantage_four_title: "隐藏源站IP",
        advantage_four_text:
          "隐藏服务器真实IP地址，使攻击者无法找到受害者网络资源，增加源站安全性。",
        architecture_web_service_title: "Web服务安全解决方案",
        architecture_competitive_text:
          "无视一切DDoS/CC攻击，网站恶意流量清洗识别，将正常、安全的流量回源到服务器。",
        architecture_target_title: "目标",
        architecture_target_text_one: "避免网站服务器被恶意入侵",
        architecture_target_text_two: "网络数据中心稳定运行",
        architecture_target_text_three:
          "解决因流量攻击导致的服务器性能异常问题",
        architecture_advantage_title: "优势",
        architecture_advantage_text_one: "全面防护",
        architecture_advantage_text_two: "隐藏源站IP",
        architecture_advantage_text_three: "低误杀秒解封",
        architecture_advantage_text_four: "无上限CC攻击防护"
      },
      financial: {
        banner_title: "金融解决方案",
        banner_text:
          "超级科技从网络、业务、数据多个维度为金融客户在应用、业务、可用等安全领域提供量身定制的个性化安全解决方案，通过立体防护机制抵御多种恶意攻击，海量计算、弹性部署解决业务的海量并发，结合资深安全专家服务，助力金融行业做到全面合规、持续发展，保障业务和数据安全。",
        financial_challenges: "金融行业面临的挑战",

        challenges_one_title: "黑客入侵",
        challenges_one_text:
          "DDoS攻击已经成为当前金融领域极其常见的安全威胁，被攻击、被“肉鸡”，以及基于DDoS的勒索事件也是逐渐趋于频繁。",
        challenges_two_title: "安全投入成本高",
        challenges_two_text:
          "金融行业机构整合云端面临技术投入大，成本高，不灵活，运维难度大，交付周期长等问题。",
        challenges_three_title: "数据安全要求高",
        challenges_three_text:
          "金融领域对于客户的隐私保护、企业的数据安全、产品安全等尤其重要，一旦泄露，不仅遭受口碑、经济上的损失，也面临着法律风险。",
        challenges_four_title: "业务欺诈",
        challenges_four_text:
          "羊毛党的垃圾注册，恶意扫号撞库，刷粉、刷票、刷积分等各种欺诈行为造成的业务损失。",

        advantage_one_title: "全面防护常见Web攻击威胁",
        advantage_one_text:
          "为HTTP／HTTPS业务提供SQL注入、XSS跨站、Webshell上传、非授权访问等多种Web服务攻击防护功能，保障网站的安全与可用性。",
        advantage_two_title: "无上限DDoS/CC攻击防护",
        advantage_two_text:
          "提供T级DDoS流量清洗防护以及千万级异常请求过滤的CC防护，有效解决黑客对金融服务器发起的流量攻击，保证业务正常进行。",
        advantage_three_title: "可视化数据分析报告",
        advantage_three_text:
          "提供详实的可视化安全数据分析报告，客户可根据需求查看历史安全记录，并可选择固定周期，自动生成详细安全报表功能。",
        advantage_four_title: "专家1V1支持",
        advantage_four_text:
          "提供1V1专属安全专家服务，快速响应客户需求，并制定专有的安全解决方案。",

        architecture_financial_title: "金融解决方案",
        architecture_competitive_text:
          "助力金融行业做到全面合规、持续发展，保障业务和数据安全。",
        architecture_target_title: "目标",
        architecture_target_text_one: "保障网站的安全与可用性",
        architecture_target_text_two: "保证业务正常进行",
        architecture_target_text_three: "提供详实的可视化安全数据分析报告",
        architecture_advantage_title: "优势",
        architecture_advantage_text_one: "全面防护",
        architecture_advantage_text_two: "无上限DDoS/CC攻击",
        architecture_advantage_text_three: "可视化数据分析报告",
        architecture_advantage_text_four: "专家1V1支持"
      },
      geme: {
        banner_title: "游戏解决方案",
        banner_text:
          "满足移动端APP、PC端等各种场景安全需求。抵御大流量攻击和CC攻击；智能加速，游戏不卡不掉线。对APP进行加固，防倒卖游戏币、防作弊、防止薅羊毛。海量攻防实战积累，为游戏运营打造可信赖的安全解决方案。",
        advantage_one_title: "高性能云服务器",
        advantage_one_text_one: "提供高性能云服务器ECS，云服务器",
        advantage_one_text_two: "计算资源独享，确保游戏服务",
        advantage_one_text_three: "稳定地运营。",
        advantage_two_title: "无上限防御",
        advantage_two_text_one: "无上限防御DDoS，超级盾(APP版)100%",
        advantage_two_text_two: "防CC，一站式解决游戏业主频繁被",
        advantage_two_text_three: "DDoS/CC攻击的烦恼。",
        advantage_three_title: "不卡不掉线",
        advantage_three_text_one: "被攻击时完全无感，游戏不卡不掉线",
        advantage_three_text_two: "分布式架构，智能路由、弱网加速，",
        advantage_three_text_three: "充分保障用户游戏体验。",
        advantage_four_title: "超高性价比",
        advantage_four_text_one: "高度可定制的解决方案，满足不同",
        advantage_four_text_two: "阶段的业务成长需求，成本比大平台",
        advantage_four_text_three: "更实惠。"
      },
      EC: {
        banner_title: "电商解决方案",
        banner_text:
          "针对电商行业高并发，垃圾流量，恶意刷单，突发大规模恶意攻击，漏洞攻击制定专属解决方案，助力电商客户应对各种业务问题，保障电商交易安全进行，电商活动顺利完成！",
        advantage_one_title: "防御性能好",
        advantage_one_text_one: "高效防DDoS攻击，CC攻击，垃圾",
        advantage_one_text_two: "流量，轻松应对各类攻击，充分保障",
        advantage_one_text_three: "促销等活动安全。",
        advantage_two_title: "流量智能调度",
        advantage_two_text_one: "分布式架构，智能DNS，智能缓",
        advantage_two_text_two: "存，轻松应对活动及其它紧急情况，",
        advantage_two_text_three: "有效降低服务器压力。",
        advantage_three_title: "数据更安全",
        advantage_three_text_one: "云WAF功能，防漏洞，防篡改，防",
        advantage_three_text_two: "SQL注入，数据指纹验证。",
        advantage_three_text_three: "充分保障用户游戏体验。",
        advantage_four_title: "服务有保障",
        advantage_four_text_one: "24小时全天候运维，提供专业的",
        advantage_four_text_two: "维护服务，对电商网站的促销活动提",
        advantage_four_text_three: "供专项保障，对安全防护状况进行监控和预警。",
        architecture_financial_title: "电商解决方案",
        architecture_competitive_text:
          "针对电商行业高并发，垃圾流量，恶意刷单，突发大规模恶意攻击，漏洞攻击制定专属解决方案。",
        architecture_target_title: "目标",
        architecture_target_text_one: "助力电商客户应对各种业务问题",
        architecture_target_text_two: "保障电商交易安全进行",
        architecture_target_text_three: "电商活动顺利完成",
        architecture_advantage_title: "优势",
        architecture_advantage_text_one: "防御性能好",
        architecture_advantage_text_two: "流量智能调度/CC攻击",
        architecture_advantage_text_three: "数据更安全",
        architecture_advantage_text_four: "服务有保障"
      },
      education: {
        banner_title: "教育行业安全解决方案",
        banner_text:
          "针对教育信息化发展所面临的网络漏洞和数据泄露风险，为教育行业提供移动APP加固、Web防火墙，防止黑客的恶意篡改、代码植入，抵御大流量攻击和CC攻击，为教育类APP、网站提供合规、安全的解决方案，助力教育信息化的安全发展。",
        education_challenges: "教育行业面临的挑战",

        challenges_one_title: "信息泄露严重",
        challenges_one_text:
          "通过代码注入、篡改等非法手段窃取用户信息，导致校园贷、电信诈骗等引发的恶性事件时有发生，被推销电话和垃圾短信频繁骚扰，苦不堪言。",
        challenges_two_title: "核心资源泄漏",
        challenges_two_text:
          "付费教学资源被盗用，文件包被劫持，造成教育企业经济损失，影响教育企业发展。",
        challenges_three_title: "受攻击风险高",
        challenges_three_text:
          "DDoS攻击已经成为教育行业极其常见的安全威胁，被攻击导致网站无法打开，学员无法完成学习，损害广大师生利益。",
        challenges_four_title: "恶意插入/篡改",
        challenges_four_text:
          "对移动APP、Web站点植入恶意广告、或篡改广告ID，非法截取企业收益。",

        advantage_one_title: "全方位的APP加固保护",
        advantage_one_text:
          "基于全方位的安全加固保护，防止移动APP被劫持、木马、入侵，采用AES256数据双向加密，防止移动APP被篡改。",
        advantage_two_title: "无上限DDoS/CC攻击防护",
        advantage_two_text:
          "提供T级DDoS流量清洗防护以及千万级异常请求过滤的CC防护，有效解决黑客对金融服务器发起的流量攻击，保证业务正常进行。",
        advantage_three_title: "全面防护常见Web攻击威胁",
        advantage_three_text:
          "为HTTP／HTTPS业务提供SQL注入、XSS跨站、Webshell上传、非授权访问等多种Web服务攻击防护功能，保障网站的安全与可用性。",
        advantage_four_title: "专家1V1支持",
        advantage_four_text:
          "提供1V1专属安全专家服务，快速响应客户需求，并制定专有的安全解决方案。",

        architecture_education_title: "教育行业安全解决方案",
        architecture_competitive_text:
          "提供移动APP加固、Web防火墙，防止黑客的恶意篡改、代码植入，抵御大流量攻击和CC攻击，为教育类APP、网站提供合规、安全的解决方案。",
        architecture_target_title: "目标",
        architecture_target_text_one: "确保服务器稳定运行",
        architecture_target_text_two: "避免用户信息的泄露",
        architecture_target_text_three: "保障付费资源不被劫持",
        architecture_advantage_title: "优势",
        architecture_advantage_text_one: "全方位的APP加固保护",
        architecture_advantage_text_two: "全面防护Web攻击威胁",
        architecture_advantage_text_three: "无上限DDoS/CC攻击防护",
        architecture_advantage_text_four: "专家1V1支持"
      }
    },
    header: {
      home: "首页",
      product: "产品",
      solution: "解决方案",
      help: "服务支持",
      information: "超级资讯",
      about: "关于我们",
      product_list: {
        network_security: "网络安全",
        data_security: "数据安全",
        super_cloud: "超级云",
        data_center: "数据中心",
        network_security_list: {
          shiled_app: "超级盾SDK（APP）",
          shiled_app_text: "针对手机APP的DDoS、CC、DNS等攻击的无限防御产品。",
          shiled_pc: "超级盾SDK（PC）",
          shiled_pc_text:
            "针对PC的DDoS、CC、DNS等攻击的无限防御产品，支持免代码接入。",
          firewall_web: "Web防火墙（网站）",
          firewall_web_text: "优质节点、分布式、智能调度、可防御ddos与cc攻击。",
          defence_ip: "高防IP",
          defence_ip_text:
            "帮助您自动智能防护DDoS攻击，减少业务损失，降低未知风险。"
        },
        data_security_list: {
          leakproof: "数据防泄漏系统",
          shiled_app_text: "针对手机APP的DDoS、CC、DNS等攻击的无限防御产品。",
          emailLeakproof: "邮件数据防泄漏系统",
          shiled_pc_text: "针对手机APP的DDoS、CC、DNS等攻击的无限防御产品。"
        },
        super_cloud: {
          defence_server: "高防服务器",
          defence_server_text: "即时部署可伸缩、可防御ddos、CC攻击的云计算。"
        },
        data_center: {
          defence_server: "高防服务器",
          defence_server_text: "即时部署可伸缩、可防御ddos、CC攻击的云计算。"
        }
      },
      solution_list: {
        scenario_solution: "场景解决方案",
        industry_solution: "行业解决方案",
        scenario_list: {
          chess: "棋牌游戏",
          chess_text:
            "抵御大流量攻击、网络加速，不卡不掉线、APP加固，防作弊、防薅羊毛等。",
          competitive_game: "竞技游戏",
          competitive_game_text:
            "智能掉配、提高网络稳定性、降低延迟、多线路近源通信。",
          web_serve: "Web服务",
          web_serve_textt: "sql注入、web渗透、拒绝服务攻击、分布式缓存加速等。"
        },
        industry_list: {
          financial: "金融",
          financial_text: "极高的网络稳定性、极低网络延迟，守护",
          game: "游戏",
          game_text:
            "防御各种形式上的网络攻击、避免对手恶意竞争、高稳定、不卡不掉线。",
          EC: "电商",
          EC_text:
            "有效防御突发大规模恶意工具，漏洞攻击，避免垃圾流量，防止恶意刷单。",
          education: "教育行业",
          education_text:
            "全方位对移动APP进行加固，防止被劫持、木马、入侵、篡改，提供SQL注入、XSS跨站、Webshell上传、非授权访问等多种Web服务攻击防护功能。"
        }
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/lang/en-new.js